export default "__VITE_ASSET__C$4d9mb8__"